const Footer = () =>
    <footer className="footer">
        <div className="footer__inner">
            <a className="footer__icon footer__icon--github" href="https://github.com/tobias290" target="_blank" rel="noopener noreferrer"><i className="fab fa-github-square" /></a>
            <a className="footer__icon footer__icon--linkedin" href="https://www.linkedin.com/in/toby-essex" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin" /></a>
            <a className="footer__icon footer__icon--facebook" href="https://www.facebook.com/toby.essextoby" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-square" /></a>
        </div>

        <small className="footer__copyright">Toby Essex &copy; {new Date().getFullYear()}</small>
    </footer>;

export default Footer;
